"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.imageLoader = void 0;
class CustomImageLoader {
    set loader(loader) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (global)
            global.__customImageLoader = loader;
        this._loader = loader;
    }
    get loader() {
        var _a;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return (_a = global === null || global === void 0 ? void 0 : global.__customImageLoader) !== null && _a !== void 0 ? _a : this._loader;
    }
}
exports.imageLoader = new CustomImageLoader();
